'use strict';
import isString from 'lodash/isString';

const SELECTED_ORGANIZATION = '@@app-model/SELECTED_ORGANIZATION';
const SELECTED_PROJECT = '@@app-model/SELECTED_PROJECT';
const SELECTED_ASSET = '@@app-model/SELECTED_ASSET';

export function selectedOrganization(id) {
  return {
    type: SELECTED_ORGANIZATION,
    payload: {
      id: isString(id) ? id : null,
    },
  };
}
selectedOrganization.TYPE = SELECTED_ORGANIZATION;

export function selectedProject(id) {
  return {
    type: SELECTED_PROJECT,
    payload: {
      id: isString(id) ? id : null,
    },
  };
}
selectedProject.TYPE = SELECTED_PROJECT;

export function selectedAsset(id) {
  return {
    type: SELECTED_ASSET,
    payload: {
      id: isString(id) ? id : null,
    },
  };
}
selectedAsset.TYPE = SELECTED_ASSET;



// WEBPACK FOOTER //
// ./src/js/app/model/actions/selectors.js